export default {
  data() {
    return {
      arrow_icon: require("@/assets/painting/arrows.png")
    };
  },
  props: {
    headImgUrl: {
      type: String,
      required: true
    },
    carousel_01: {
      type: String,
      required: true
    },
    carousel_02: {
      type: String,
      required: true
    },
    carousel_03: {
      type: String,
      required: true
    },
    carousel_04: {
      type: String,
      required: true
    },
    carousel_05: {
      type: String,
      required: true
    },
    carousel_06: {
      type: String,
      required: true
    },
    ex_original: {
      type: String,
      required: true
    },
    ex_target: {
      type: String,
      required: true
    },
    shopUrl: {
      type: String,
      required: true
    },
    product_introduce: {
      type: String,
      required: true
    }
  },
  computed: {
    get_product_introduce() {
      let introduce = this.product_introduce;
      let parts = introduce.split(/\[|\]/);
      let product_introduce = parts[0].trim();
      return product_introduce;
    },
    get_product_part() {
      let introduce = this.product_introduce;
      let parts = introduce.split(/\[|\]/);
      if (parts.length < 2) {
        return "";
      }
      let product_part = parts[1].trim();
      let part_list = product_part.split(';');

      // console.log("parts: ", part_list);

      return part_list;
    }
  },
  methods: {}
};